var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormRulesProvider',{attrs:{"module-name":_vm.$constants.TASK}},[_c('FlotoModule',[(_vm.hasTaskAccess)?[_c('RouterView',{key:_vm.$route.fullPath})]:_vm._e()],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }